import request from './request'

// 管理员登录
export function login(data) {
  return request({
    url: '/admin/auth/login',
    method: 'post',
    data
  })
}

// 获取当前登录管理员信息
export function getInfo() {
  return request({
    url: '/admin/admin/info',
    method: 'get'
  })
}
